angular.module('property-deal')
    .component('propertyDealAgreements', {
        bindings: {
            propertyDeal: '<'
        },
        templateUrl: 'app/property-deal/_agreements.html'
    })
